import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { AdsState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { ListStatus, EditableStatus } from '@/store/types';
import Ad from './ad';

const state: AdsState = {
  list: [],
  listStatus: ListStatus.Loading,
  listPagination: {
    currentPage: 1,
    lastPage: 1,
    total: 0,
    clickPeriod: null,
  },
  editable: null,
  initialEditable: null,
  editableStatus: EditableStatus.Loading,
  products: [],
  countries: [],
};

const ads: Module<AdsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default ads;
